import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import api from './../../services/api';

import { Container, Row, ContainerMain } from './styles';

export const InfoContact = ({ query }) => {
  const [contact, setContact] = useState({});

  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const contactUrl =
        label && page_label
          ? `pages/sections/contact/get/${label}/${page_label}`
          : `pages/sections/contact/get/${label}`;

      try {
        const { data } = await api.get(contactUrl);

        // Verificação de segurança para evitar erros quando data.data é undefined
        if (data && data.data) {
          setContact(data.data);
        } else {
          console.warn('API response data structure is invalid in InfoContact component:', data);
          setContact({});
        }
      } catch (error) {
        console.error('Error loading contact info:', error);
        setContact({});
      }
    }

    let isMoutend = true;

    if (isMoutend && query) {
      load();
    }

    return () => {
      isMoutend = false;
    };
  }, [query]);

  return (
    <Container active={contact?.active}>
      <ContainerMain>
        <Row>
          <FontAwesomeIcon icon={faLocationDot} />
          <div>
            <h2>{contact.address}</h2>
            <h2>
              {contact.city}-{contact.state}, {contact.country}
            </h2>
          </div>
        </Row>
        {contact?.telephone !== null && (
          <Row>
            <FontAwesomeIcon icon={faPhone} />
            <div>
              <h2>{contact.telephone}</h2>
            </div>
          </Row>
        )}
      </ContainerMain>
    </Container>
  );
};
